import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, EmptyState } from "@/components/common";
import { ReferralPanel } from "@/components/referrals/ReferralPanel";
import { api, errMsg } from "@/lib/api";

export default function Referrals() {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/referrals/me").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const savePix = async (pix_key) => { await api.put("/referrals/me/pix", { pix_key }); await load(); };
  return (
    <>
      <PageHeader eyebrow="Sistema" title="Indicações" subtitle="Indique o sistema para outros negócios e ganhe comissão sobre as mensalidades." />
      {!data ? <p className="text-sm text-muted-foreground" data-testid="referral-loading">Carregando...</p>
        : !data.eligible ? <EmptyState icon={Share2} title="Disponível para clientes com plano ativo" text="Assine um plano para receber seu link de indicação e começar a ganhar comissão."
          action={<Button asChild data-testid="referral-go-plans-btn"><Link to="/app/planos">Ver planos</Link></Button>} />
          : <ReferralPanel data={data} onSavePix={savePix} />}
    </>
  );
}
